import Vue from 'vue';
import Vuex from 'vuex';
import report from './modules/report';
import auth from './modules/auth';
import checkout from './modules/checkout';
import discount from './modules/discount';
import outlet from './modules/outlet';
import shifts from './modules/shifts';
import tag from './modules/tag';
import tax from './modules/tax';
import payment from './modules/payment';
import product from './modules/product';
import reportProduct from './modules/report-product';
import category from './modules/category';
import region from './modules/region';
import label from './modules/label';
import tradingArea from './modules/trading-area';
import zone from './modules/zone';
import centralSettings from './modules/central-settings';
import hubSettings from './modules/hub-settings';
import variant from './modules/variant';
import central from './modules/central';
import till from './modules/till';
import reimbursement from './modules/reimbursement';
import fuelTransaction from './modules/fuel-transaction';
import fuelSalesByTank from './modules/fuel-sales-by-tank';
import localAccount from './modules/local-account';
import royalty from './modules/royalty';
import salesCategory from './modules/sales-category';
import bestSeller from './modules/best-seller';
import salesMix from './modules/sales-mix';
import receiptPromotion from './modules/receipt-promotion';
import hourly from './modules/hourly';
import tillFilter from './modules/till-filter';
import tillSummary from './modules/till-summary';
import stockMovement from './modules/inventory-stock-movement';
import inventoryStockReceive from './modules/inventory-stock-receive';
import stockReturn from './modules/inventory-stock-return';
import inventoryStockCheck from './modules/inventory-stock-check';
import voidedSales from './modules/voided-sales';
import timezone from './modules/timezone';
import currency from './modules/currency';
import profit from './modules/profit';
import costGoodSold from './modules/cost-good-sold';
import meta from './modules/meta';
import card from './modules/card';
import ewallet from './modules/ewallet';
import subsidy from './modules/subsidy';
import stockTransfer from './modules/stock-transfer';
import inventoryEodReport from './modules/inventory-eod-report';
import paymentReport from './modules/payment-report';
import fuelDipping from './modules/fuel-dipping';
import customReceipt from './modules/custom-receipt';
import fuelReceiving from './modules/fuel-receiving';
import virtualShift from './modules/virtual-shift';
import uom from './modules/uom';
import attendantTagging from './modules/attendant-tagging';
import shelfLabel from './modules/shelf-label';
import attendantSession from './modules/attendant-session';
import transactionPostgres from './modules/transaction-postgres';
import shellAppVoucherPromotion from './modules/shell-app-voucher-promotion';
import shellReimbursement from './modules/shell-reimbursement';
import ghlReimbursement from './modules/ghl-reimbursement';
import cartPostgres from './modules/cart-postgres';
import inventorySupplier from './modules/inventory-supplier';
import inventoryDistributor from './modules/inventory-distributor';
import exportDetail from './modules/export-detail';
import reportWizard from './modules/report-wizard';
import fuelPrice from './modules/fuel-price';
import shelfSpacePlan from './modules/shelf-space-plan';
import dailyReconciliation from './modules/daily-reconciliation';
import measurement from './modules/measurement';
import restriction from './modules/restriction';
import customerEngagement from './modules/customer-engagement';
import subsidyReimbursementReport from './modules/subsidy-reimbursement-report';
import tngSubsidyReimbursementReport from './modules/tng-subsidy-reimbursement-report';

import { createVuexLoader } from 'vuex-loading';

const VuexLoading = createVuexLoader({
    moduleName: 'loading',
    componentName: 'v-loading',
    className: 'v-loading',
});

Vue.use(Vuex);
Vue.use(VuexLoading);

export default new Vuex.Store({
    plugins: [VuexLoading.Store],
    modules: {
        report,
        auth,
        checkout,
        discount,
        outlet,
        shifts,
        tag,
        payment,
        product,
        tax,
        reportProduct,
        category,
        centralSettings,
        hubSettings,
        variant,
        central,
        region,
        till,
        localAccount,
        tradingArea,
        zone,
        fuelTransaction,
        fuelSalesByTank,
        royalty,
        salesCategory,
        bestSeller,
        salesMix,
        receiptPromotion,
        tillFilter,
        tillSummary,
        stockMovement,
        inventoryStockReceive,
        stockReturn,
        inventoryStockCheck,
        voidedSales,
        timezone,
        currency,
        profit,
        costGoodSold,
        hourly,
        label,
        meta,
        stockTransfer,
        inventoryEodReport,
        card,
        subsidy,
        customReceipt,
        paymentReport,
        fuelDipping,
        fuelReceiving,
        uom,
        ewallet,
        reimbursement,
        virtualShift,
        attendantTagging,
        shelfLabel,
        attendantSession,
        transactionPostgres,
        shellAppVoucherPromotion,
        shellReimbursement,
        ghlReimbursement,
        cartPostgres,
        inventorySupplier,
        inventoryDistributor,
        exportDetail,
        reportWizard,
        fuelPrice,
        shelfSpacePlan,
        dailyReconciliation,
        measurement,
        restriction,
        customerEngagement,
        subsidyReimbursementReport,
        tngSubsidyReimbursementReport,
    },
});
